import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";

import '../utils/extended-date'
import {Utilities} from "../utils/utilities";
import {BaseRepository} from "./base/base.repository";

@Injectable({
    providedIn: 'root'
})
export class VoucherRepository extends BaseRepository {
    private readonly staffPath: string;

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.path = 'dashboard/admin/vouchers';
        this.staffPath = 'dashboard/staff/vouchers';
    }


    saveNewValidity(validity: Date, productNumber: string) {
        // TODO menteni, amint meglesz a végpont módosítása GET -> PATCH
        const path = this.path + '/modify-date/' + productNumber;
        let parameters = new HttpParams().append('productNumber', productNumber);
        parameters = parameters.append('validity-date', Utilities.dateToBackendString(validity));
        const options = {params: parameters};
        return super.get(path, options);
    }

    findByProductNumberAndDeliveryReservationIsNull(productNumber: string) {
        const path = this.staffPath + "/" + productNumber + "/for-delivery";
        return super.get(path);
    }

    findByProductNumberAndReservationExtraIsNull(productNumber: string) {
        const path = this.staffPath + "/" + productNumber + "/for-reservation";
        return super.get(path);
    }

    redeem(productNumber: string, restaurantHistoryId: number) {
        const path = this.path + '/used/' + productNumber + "/" + restaurantHistoryId;
        return super.get(path);
    }

    convertVoucher(productNumber: string, selectedGiftCardId: number, personCount: number) {
        const path = this.path + '/convert';
        let parameters = new HttpParams().append('voucher-product-number', productNumber);
        parameters = parameters.append('product-id', selectedGiftCardId.toString());
        parameters = parameters.append('person-count', personCount.toString());
        const options = {params: parameters};

        const payload = {
            id: null,
            type: 'VOUCHER',
            attribute: {}
        };

        return super.post(path, payload, options);
    }

    declineAndRegenerate(productNumber: string, resendEmail:string) {
        const path = this.path + '/' + productNumber + '/reject-and-regenerate';
        return super.patch(path, {id:null, type:'reject-regenerate', attribute:resendEmail});
    }

    decline(productNumber: string) {
        const path = this.path + '/' + productNumber + '/reject';
        return super.patch(path);

    }
}
